module.exports = "/_next/static/images/bg-video-block-06b5d55b02b7da274faedbe4b6453a88.jpg.webp";